import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CBaseComponent } from '../base/c-base.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { SHeaderComponent } from '../../shared/s-header/s-header.component';
import { BaseSingleColumnTextImageComponent } from './base-single-column-text-image/base-single-column-text-image.component';

@Component({
    selector: 'app-c-single-column-text-image',
    imports: [
        SHeaderComponent,
        BaseSingleColumnTextImageComponent
    ],
    templateUrl: './c-single-column-text-image.component.html',
    styleUrl: './c-single-column-text-image.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CSingleColumnTextImageComponent extends CBaseComponent implements OnInit {
  override ngOnInit() {
    this.singleLabels = [ElementsType.ComponentHeader, ElementsType.ServiceDetails];
    super.ngOnInit();
  }
}